module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Messente settings","username":"Username","password":"Password"},"et":{"title":"Messente settings","username":"Username","password":"Password"},"ru":{"title":"Messente settings","username":"Username","password":"Password"}}')
  delete Component.options._Ctor
}
